import { render, staticRenderFns } from "./TabsTable.vue?vue&type=template&id=4fce89a1&scoped=true"
import script from "./TabsTable.vue?vue&type=script&lang=js"
export * from "./TabsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fce89a1",
  null
  
)

export default component.exports